import type { DomainMapper } from '../types';

const se: DomainMapper = {
  countryCode: 'se',
  currency: 'SEK',
  dataAreaId: 'se01',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/1x1/SE.svg',
  languagePrimary: true,
  locale: 'sv',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-se.xml',
  storyblokBasePath: 'se',
  url: 'https://localhost:3011/se',
  algoliaIndex: 'b2b-se-sv-SE-products',
  algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1156, // stage
  // applicationId: 1155, // prod
  subFolder: true,
  // norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech', // uncomment to get icons from stage instead

  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1156, // stage
    // applicationId: 1155, // prod
    algoliaIndex: 'b2b-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2b-se-sv-SE-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-se.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1468, // stage
    // applicationId: 1473, // prod
    algoliaIndex: 'b2c-se-sv-SE-products',
    algoliaIndexAutocomplete: 'b2c-se-sv-SE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-se-b2c.xml',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
  },
  showNonPublicProducts: false,
} as DomainMapper;

export default se;
